/** Opacity cap for a shape locked by another user. */
export const REMOTE_LOCK_MAX_OPACITY = 0.6

function clampUnit(value: number): number {
  return Math.max(0, Math.min(1, value))
}

/**
 * Opacity of the whole shell, text included. Group Isolation Mode can dim objects outside the
 * active group subtree, and a remote lock dims further.
 */
export function resolveShellOpacity(opacityMultiplier: number, remoteLocked: boolean): number {
  const opacity = clampUnit(opacityMultiplier)

  return remoteLocked ? Math.min(opacity, REMOTE_LOCK_MAX_OPACITY) : opacity
}

/**
 * Opacity of the object layer only. The Transparency effect (`shape.opacity`) belongs to the
 * object's fill, photo and stroke — text on a path shares the shell's <svg> and must stay
 * untouched (WMPCM-11388).
 */
export function resolveObjectOpacity(shapeOpacity: number | undefined): number {
  return clampUnit(shapeOpacity ?? 1)
}
